import { render } from "./FormCadSolicitacaoVeterinario.vue?vue&type=template&id=68d665b7&scoped=true"
import script from "./FormCadSolicitacaoVeterinario.vue?vue&type=script&lang=js"
export * from "./FormCadSolicitacaoVeterinario.vue?vue&type=script&lang=js"

import "./FormCadSolicitacaoVeterinario.vue?vue&type=style&index=0&id=68d665b7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d665b7"]])

export default __exports__